import './Article.sass';

import heroL from '../assets/hero/front-b-l.jpg';
import Hero from '../components/Hero';
import Breadcrumbs from '../components/Breadcrumbs';

import { Link } from 'react-router-dom';

const Article = () => {
	return (
		<div className='Article'>
			<Hero data={[{ pic: heroL, description: '永續投資' }]} />

			<Breadcrumbs
				data={[
					{ url: '', name: '麵包屑', guid: 'a' },
					{ url: '', name: '麵包屑', guid: 'b' },
				]}
			/>

			<div className='common-pad-wrap'>
				<div className='flex-top'>
					<div className='left'>
						<h2>企業永續發展盡職治理</h2>
					</div>
				</div>

				<div className='content'>
					<div className='customized diligence'>
						<div className='section-title center'>
							大華資產管理將支持以下
							<span className='br'>
								<br></br>
							</span>
							6個永續發展倡議(SDG)<div className='line'></div>
						</div>

						<img className='l' src='/assets/sustainability/diligence1-l.jpg' alt='' />

						<div className='slide'>
							<img className='m' src='/assets/sustainability/diligence1-m.jpg' alt='' />
						</div>

						<div className='section-title center'>
							大華資產集團2021年即將舉辦的
							<span className='br'>
								<br></br>
							</span>
							永續發展倡議(SDG)活動<div className='line'></div>
						</div>

						<img className='l' src='/assets/sustainability/diligence2-l.jpg' alt='' />

						<div className='sub-title m special'>永續性工作場所與永續性採購計畫</div>
						<img className='m' src='/assets/sustainability/diligence21-m.jpg' alt='' />

						<div className='sub-title m'>永續性發展意識計畫</div>
						<img className='m' src='/assets/sustainability/diligence22-m.jpg' alt='' />

						<div className='sub-title m'>食物捐贈計畫</div>
						<img className='m' src='/assets/sustainability/diligence23-m.jpg' alt='' />

						<div className='sub-title m'>綠化項目（沿海/紅樹林/森林/山地）</div>
						<img className='m' src='/assets/sustainability/diligence24-m.jpg' alt='' />
					</div>
				</div>

				<div className='button-wrap'>
					<Link to='' className='common-button'>
						回列表
					</Link>
				</div>
			</div>
		</div>
	);
};

export default Article;
